<div
    class="card"
    [style.min-height]="minHeight()"
    [style.max-height]="maxHeight()"
    [style.height]="height()"
    [ngClass]="cardClasses()"
>
    @if (headerTemplate) {
        <div
            class="card-header"
            [ngClass]="[headerClass(), !isExpanded() ? 'no-body' : '']"
        >
            <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
        </div>
    }

    @if (bodyTemplate && isExpanded()) {
        <div class="card-body" [ngClass]="bodyClass()">
            <ng-container *ngTemplateOutlet="bodyTemplate"></ng-container>
        </div>
    }

    @if (footerTemplate) {
        <div class="card-footer" [ngClass]="footerClass()">
            <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
        </div>
    }

    <ng-content></ng-content>
</div>
